module.exports={
	"Form": "RoleEditManifest",
	"Scope": "Role-Edit",
	"Descriptors":
	{
		"RoleDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RoleEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleEditIdentity",
				"Group": "RoleEditIdentity"
			}
		},
		"RoleDetails.GUIDRole":
		{
			"Name": "GUID",
			"Hash": "RoleEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleEditIdentity",
				"Group": "RoleEditIdentity"
			}
		},
		"RoleDetails.Name":
		{
			"Name": "Role Name",
			"Hash": "RoleEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "RoleEditIdentity",
				"Group": "RoleEditIdentity"
			}
		},
		"RoleDetails.Description":
		{
			"Name": "Description",
			"Hash": "RoleEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		},
		"RoleDetails.PermissionLevel":
		{
			"Name": "Permission Level",
			"Hash": "RoleEdit-PermissionLevel",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		},
		"RoleDetails.Type":
		{
			"Name": "Role Type",
			"Hash": "RoleEdit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 3,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		},
		"RoleDetails.LinkedIDUser":
		{
			"Name": "Linked User ID",
			"Hash": "RoleEdit-LinkedIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "RoleEditConfig",
				"Group": "RoleEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RoleEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RoleEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RoleEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RoleEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
